export const META_NAV_ID_PROFILE = "profile";
export const META_NAV_ID_LOCALE = "locale-selection";
export const META_NAV_ID_HOME = "home";
